import { inject, Injectable } from '@angular/core';
import { TeilaufgabenService } from '../../services/teilaufgaben-service';

@Injectable({
  providedIn: 'root'
})
export class TeilaufgabenCopyService {


  private teilaufgabenService = inject(TeilaufgabenService);

  private clipboardTeilaufgabenId: string = ""

  constructor() {

    this.loadFromLocalstorage();
    window.addEventListener("storage", (e) => {
      this.loadFromLocalstorage();
    })
  }
  private loadFromLocalstorage() {
    try {
      const t = localStorage.getItem("teilaufgabenClipboard");
      if (t != null) {
        this.clipboardTeilaufgabenId = t
      }
    } catch (e) {
      console.warn("no localstorage access")
    }
  }

  public clearClipboard() {
    this.clipboardTeilaufgabenId = "";
    try {
      localStorage.setItem("teilaufgabenClipboard", "");
    } catch (e) {
      console.warn("no localstorage access")

    }
  }

  public async copy(teilaufgabenId: string) {
    this.clipboardTeilaufgabenId = teilaufgabenId;
    try {
      localStorage.setItem("teilaufgabenClipboard", teilaufgabenId);
    } catch (e) {
      console.warn("no localstorage access")
    }
  }
  public async paste(targetAufgabe: string) {
    if (!this.isTeilaufgabeinClipboard()) {
      console.warn("Copy Teilaufgabe first");
    }
    return this.teilaufgabenService.pasteTeilaufgabe(this.clipboardTeilaufgabenId, targetAufgabe)
  }
  public isTeilaufgabeinClipboard() {
    return this.clipboardTeilaufgabenId != ""
  }
}
